export default function() {
  return {
    restrict: 'EA',
    template:
      '<table class="table table-bordered"> <thead> <th ng-repeat="header in headers"> {{header}} </th> </thead> <tbody> <tr ng-repeat="row in rows "> <td ng-repeat="data in row track by $index"> {{ data }} </td> </tr> </tbody> </table>',
    controller: [
      '$scope',
      function($scope) {
        $scope.headers = []
        $scope.rows = []

        function setTableHeaders(row) {
          $scope.headers = []
          if (row['_id']) {
            var idKeys = Object.keys(row['_id'])
            $scope.headers = $scope.headers.concat(idKeys)
          }
          var objKeys = Object.keys(row)
          $scope.headers = $scope.headers.concat(objKeys)
          if ($scope.headers.indexOf('_id') >= 0) {
            $scope.headers.splice($scope.headers.indexOf('_id'), 1)
          }
        }

        function setTableRows(rowData) {
          $scope.rows = []
          rowData.forEach(function(val, idx, arr) {
            var row = []

            $scope.headers.forEach(function(header) {
              var dataVal = val[header] ? val[header] : val['_id'] && val['_id'][header]

              if (Object.prototype.toString.call(dataVal) === '[object Array]') {
                dataVal = dataVal.join(', ')
              }

              row.push(dataVal)
            })

            $scope.rows.push(row)
          })
        }

        function tabelizeObject(reportString) {
          var rowStrs = reportString.trim().split('\n')

          $scope.headers = rowStrs[0].split(',')
          $scope.rows = []

          rowStrs.slice(1).forEach(function(rowStr, idx, arr) {
            $scope.rows.push(rowStr.split(','))
          })
        }

        // watch for report data changes
        $scope.$watch('reportData', function(nVal, oVal) {
          if (nVal && nVal.length > 0) {
            // Used for domain level reports
            if (Object.prototype.toString.call(nVal) === '[object Array]') {
              setTableHeaders(nVal[0])
              setTableRows(nVal)
            }

            // Used for activation reports CSV
            // TODO: just send everything as CSV... not JSON... better for tabelizing anyways
            if (Object.prototype.toString.call(nVal) === '[object String]') {
              tabelizeObject(nVal)
            }
          }
        })
      }
    ],
    scope: {
      reportData: '='
    }
  }
}
